/* eslint-disable max-len */
import {AppType} from '@web-catalog/types';
import {
  METADATA_OVERRIDE_LOAD_MODES,
  SSP_AD_MODES,
  SSP_PARTNER_AD_MODES,
  WEB_AUTO_LOGIN,
  YANDEX_AD_MODES,
} from '@web-catalog/types/omicron';

import {
  AdFoxConfigValidator,
  ConfigSchema,
  getArray,
  getBoolean,
  getBooleanNumberMap,
  getNumber,
  getString,
  getStringArrayMap,
  getStringMap,
  getStringUnion,
  InferConfigType,
  OmicronConfigResponseType,
  WithTypeCheck,
} from '@utils/omicron';

import {
  EngagementPopupOptionsValidator,
  NewMainPageBlocksOrderConfigValidator,
  PopupOptionsValidator,
  RoundingRulesValidator,
  YandexMetricaFeaturesValidator,
} from './customValidators';

export const OmicronConfigSchema = {
  WEB_TECHNICAL_WORKS: {
    value: getBoolean(),
    
    
  },
  WEB_AUTO_DOWNLOAD: {
    value: getBoolean(),
    
    
  },
  RULES_FOR_DOWNLOADS_COUNT_GAMES: {
    value: RoundingRulesValidator,
    
    
  },
  RULES_FOR_DOWNLOADS_COUNT_APPS: {
    value: RoundingRulesValidator,
    
    
  },
  WEB_SIMILAR_APPS_DISCLAIMER: {
    value: getBoolean(),
    
    
  },
  WEB_SEARCH_EXPS: {
    value: getString(),
    
    
  },
  WEB_YANDEX_AD_MODE: {
    value: getStringUnion('none', YANDEX_AD_MODES),
    
    
  },
  WEB_AUTO_LOGIN: {
    value: getStringUnion('none', WEB_AUTO_LOGIN),
    
    
  },
  WEB_ENABLE_SELECTIONS_STRAPI: {
    value: getBoolean(),
    
    
  },
  WEB_SSP_AD_MODE: {
    value: getStringUnion('none', SSP_AD_MODES),
    
    
  },
  WEB_SSP_AD_PARTNER: {
    value: getStringUnion('none', SSP_PARTNER_AD_MODES),
    
    
  },
  WEB_SSP_AD_WITH_AUTH: {
    value: getBoolean(),
    
    
  },
  SSP_BANNER_REFRESH: {
    value: getBooleanNumberMap(),
    
    
  },
  WEB_YANDEX_AD_RIGHT_SIDEBAR_ENABLED: {
    value: getBoolean(),
    
    
  },
  WEB_YANDEX_AD_APPS_LIST_ENABLED: {
    value: getBoolean(),
    
    
  },
  YANDEX_AD_NEW_APP_CARD_ENABLED: {
    value: getBoolean(),
    
    
  },
  WEB_GAME_MARKINGS_ENABLED: {
    value: getBoolean(),
    
    
  },
  WEB_ENABLE_NEW_DEEPLINK: {
    value: getBoolean(),
    
    
  },
  WEB_ENABLE_NEW_SCHEME_DEEPLINK: {
    value: getBoolean(),
    
    
  },
  WEB_ENABLE_REDIRECT_FROM_APPCARD: {
    value: getBoolean(),
    
    
  },
  WEB_SELECTIONS_ON_MAIN_BLOCK_ORDER: {
    value: NewMainPageBlocksOrderConfigValidator,
    
    
  },
  WEB_SHOW_VIDEO_IN_APP_SCREENSHOTS: {
    value: getBoolean(),
    
    
  },
  WEB_YANDEX_PLACEMENTS_APPS: {
    value: getStringMap(),
    
    
  },
  WEB_YANDEX_PLACEMENTS_GAMES: {
    value: getStringMap(),
    
    
  },
  ENABLE_LAZY_SCRIPTS: {
    value: getBoolean(),
    
    
  },
  ADFOX_CONFIG: {
    value: AdFoxConfigValidator,
    
    
  },
  ENABLE_KIOSK_PAGE: {
    value: getBoolean(),
    
    
  },
  ENABLE_TV_APP_PAGE: {
    value: getBoolean(),
    
    
  },
  ENABLE_NEW_OVERALL_INFO_API: {
    value: getBoolean(),
    
    
  },
  ENABLE_FILTERS: {
    value: getBoolean(),
    
    
  },
  ENABLE_INAPPSTORY: {
    value: getBoolean(),
    
    
  },
  ENABLE_APP_ARTICLES: {
    value: getBoolean(),
    
    
  },
  ENABLE_EVENTS_IN_APP: {
    value: getBoolean(),
    
    
  },
  ENABLE_APP_GRADIENT: {
    value: getBoolean(),
    
    
  },
  ENABLE_APP_LABEL_IN_APPS_LIST: {
    value: getBoolean(),
    
    
  },
  ENABLE_SUGGEST_ADS: {
    value: getStringUnion('', ['banner', 'sticker', 'all'] as const),
    
    
  },
  ENABLE_LLM_REVIEWS: {
    value: getBoolean(),
    
    
  },
  CATEGORIES_WITH_HIDDEN_FILTERS: {
    value: getStringArrayMap<AppType>({fallback: {}}),
    
    
  },
  INP_REPORTING_THRESHOLD_MS: {
    value: getNumber(0),
    
    
  },
  METADATA_OVERRIDES_LOAD_MODE: {
    value: getStringUnion('none', METADATA_OVERRIDE_LOAD_MODES),
    
    
  },
  YANDEX_METRIKA_FEATURES: {
    value: YandexMetricaFeaturesValidator,
    
    
  },
  TRENDS_IN_SEARCH_AMOUNT: {
    value: getNumber(0),
    
    
  },
  EXCLUDED_HEADER_LINK_TITLES: {
    value: getArray<string>([], (val) => typeof val === 'string'),
    
    
  },
  ENABLE_NEW_DOWNLOADS_COUNT: {
    value: getBoolean(),
    
    
  },
  ENGAGEMENT_POPUP_CONFIG: {
    value: EngagementPopupOptionsValidator,
    
    
  },
  APP_EVENT_POPUP_CONFIG: {
    value: PopupOptionsValidator,
    
    
  },
  ENABLE_MANUAL_MODERATION_TAG: {
    value: getBoolean(),
    
    
  },
  ENABLE_APP_PERMISSIONS: {
    value: getBoolean(),
    
    
  },
  ENABLE_FOOTER_MODALS: {
    value: getBoolean(),
    
    
  },
  ENABLE_APP_STRAPI_CONFIGS_BATCH_MODE: {
    value: getBoolean(true),
    
    
  },
} satisfies ConfigSchema;

export type OmicronContent = InferConfigType<
  WithTypeCheck<typeof OmicronConfigSchema>
>;

export type OmicronFlags = keyof typeof OmicronConfigSchema;

export type OmicronDTO = OmicronConfigResponseType<OmicronContent> & {
  /**
   * если не получили конфиг через заголовки на сервер-сайде и сходили в омикрон сами,
   * то оид надо будет записать в куку с клиента
   */
  writeOidCookie?: boolean;
};
